document.addEventListener('DOMContentLoaded', () => {
	const blocks = document.querySelectorAll('.rmh-donation-ask');

	blocks.forEach((block) => {
		// Block initialization logic.
	});
});
